<template>
  <!-- 多条查询 -->
  <el-dialog
    title="多条查询"
    custom-class="check-orders"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="visibleOrderSearch"
    width="450px"
    append-to-body
  >
    <div class="main">
      <el-form
        ref="searchOrderForm"
        :label-width="labelWidth"
        :model="searchOrderForm"
      >
        <div class="edit-content">
          <el-form-item class="edit-title" :label="label">
            <el-input
              type="textarea"
              :rows="8"
              v-model="searchOrderForm.orderNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <section class="search-order">
            <i class="e6-icon-abnormal_line"></i
            ><span class="tips">
              多个{{ tipsLabel }}，请用<span>分号 </span><span>逗号 </span>
              <span>空格</span>或<span>回车</span>隔开</span
            >
          </section>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitOrderNoSearch">确 认</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "multipleOrderSearch",
  props: {
    label: {
      type: String,
      default: "订单号"
    },
    labelWidth: {
      type: String,
      default: "70px"
    },
    tipsLabel: {
      type: String,
      default: "单号"
    }
  },
  data() {
    return {
      visibleOrderSearch: false,
      searchOrderForm: { orderNo: "" }
    };
  },
  methods: {
    handleOpen(val) {
      this.visibleOrderSearch = true;
      this.searchOrderForm.orderNo = val;
    },
    submitOrderNoSearch() {
      this.$emit("search", this.searchOrderForm);
      this.visibleOrderSearch = false;
    }
  }
};
</script>
